// Central list of mix food photos used on Gallery & Home pages.
// To add a new photo: drop the .webp into /public/mix-photos/ and add a line here.
export const mixPhotos = [
  { src: "/mix-photos/mix-6.webp", alt: "Roze · chef's mix" },
  { src: "/mix-photos/mix-10.webp", alt: "Roze · chef's mix" },
  { src: "/mix-photos/mix-16.webp", alt: "Roze · chef's mix" },
  { src: "/mix-photos/mix-20.webp", alt: "Roze · chef's mix" },
  { src: "/mix-photos/mix-21.webp", alt: "Roze · chef's mix" },
  { src: "/mix-photos/mix-28.webp", alt: "Roze · chef's mix" },
  { src: "/mix-photos/mix-43.webp", alt: "Roze · chef's mix" },
  { src: "/mix-photos/mix-55.webp", alt: "Roze · chef's mix" },
  { src: "/mix-photos/mix-62.webp", alt: "Roze · chef's mix" },
  { src: "/mix-photos/mix-63.webp", alt: "Roze · chef's mix" },
];
